// A person's own table layout: which columns they have hidden and the order
// they have dragged the rest into. `columns` is the page's definition list
// ({ key, locked? }); a locked column can be moved but never hidden.

// Reconcile a saved layout with today's columns. A column added since the
// layout was saved shows, slotted in after the column it follows by default,
// so new columns are never silently missing; one since removed is dropped.
export function resolveLayout(columns, saved) {
  const keys = columns.map(c => c.key);
  const locked = new Set(columns.filter(c => c.locked).map(c => c.key));
  const savedOrder = Array.isArray(saved?.order) ? saved.order : [];
  const savedHidden = Array.isArray(saved?.hidden) ? saved.hidden : [];

  const order = savedOrder.filter(k => keys.includes(k));
  keys.forEach((k, i) => {
    if (order.includes(k)) return;
    const prev = keys.slice(0, i).reverse().find(p => order.includes(p));
    order.splice(prev ? order.indexOf(prev) + 1 : 0, 0, k);
  });
  return { order, hidden: savedHidden.filter(k => keys.includes(k) && !locked.has(k)) };
}

// Move `key` into the place `target` holds. Used both for a drop and for the
// up / down buttons, where the target is the neighbour.
export function moveColumn(order, key, target) {
  const to = order.indexOf(target);
  if (key === target || to < 0 || !order.includes(key)) return order;
  const next = order.filter(k => k !== key);
  next.splice(to, 0, key);
  return next;
}

export function visibleColumns(columns, layout) {
  const byKey = Object.fromEntries(columns.map(c => [c.key, c]));
  return layout.order.filter(k => !layout.hidden.includes(k)).map(k => byKey[k]).filter(Boolean);
}

// Does a row pass the filters under the columns given (the visible ones, so a
// hidden column filters nothing)? A text filter is a column's `match` against
// what was typed; a pick-list passes the row when its `filter.value` is any of
// those picked. A filter left empty passes every row.
export function passesColumnFilters(row, columns, filters) {
  return columns.every(c => {
    const v = filters[c.key];
    if (!c.filter || !v?.length) return true;
    return c.filter.text ? c.match(row, v) : v.includes(c.filter.value(row));
  });
}
